<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-link :to="{ name: 'dinamicas' }">Regresar</b-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <h2>Preguntas {{ encuesta.nombre }} <span v-if="$auth.can('agregar_preguntas') && encuesta.estado === 'ACTIVA'">
            <b-button size="sm" variant="info" @click.prevent="agregar">
              <b-icon icon="plus-square"></b-icon> Agregar
            </b-button>
          </span></h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        Texto de ayuda: Esta sección permite agregar preguntas a la encuesta, recuerde que antes de crear preguntas debe haber creado por lo menos un grupo
      </b-col>
    </b-row>
    <b-form ref="filtros" @submit.prevent="cargarPreguntas">
      <b-form-row>
        <b-col sm="6">
          <b-form-group label="Texto:" label-for="input-filtro-texto">
            <b-form-input id="input-filtro-texto" type="text" v-model="filtros.texto"></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-button variant="primary" type="submit">Filtrar</b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <b-row>
      <b-col md="12">
        <b-table responsive striped hover :items="preguntas" :fields="campos" v-table-group>
          <template #cell(grupo)="row">
            {{ nombreGrupo(row.item) }}
          </template>
          <template #cell(vigencia)="row">
            {{ nombreVigencia(row.item) }}
          </template>
          <template #cell(tipo)="row">
            {{ nombreTipoCampo(row.item) }}
          </template>
          <template #cell(acciones)="row">
            <b-link href="" @click.prevent="editar(row.item)" v-if="$auth.can('editar_dinamicas') && encuesta.estado === 'ACTIVA'">Editar</b-link>
            <b-link href="" @click.prevent="eliminar(row.item)" v-if="$auth.can('eliminar_dinamicas') && encuesta.estado === 'ACTIVA'">Eliminar</b-link>
          </template>
        </b-table>
        <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
      </b-col>
    </b-row>
    <b-modal v-model="mainModal" size="xl" no-close-on-backdrop>
      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Identificador de la pregunta:" label-for="input-identificador" :invalid-feedback="errores.identificador" :state="$empty(errores.identificador)">
          <b-input-group>
            <b-form-input id="input-identificador" list="input-identificador-list" v-model="pregunta.identificador" :state="$empty(errores.identificador)" :readonly="disabled.identificador" trim autocomplete="off"></b-form-input>
            <template #append>
              <b-dropdown text="Caracterización" variant="outline-success">
                <b-dropdown-item @click="usarModelo(null)">Limpiar</b-dropdown-item>
                <b-dropdown-item v-for="(campo, index) in modelo" :key="index" @click="usarModelo(campo)">{{campo.id}}<br><small>{{ campo.texto }}</small></b-dropdown-item>
              </b-dropdown>
            </template>
          </b-input-group>
          <datalist id="input-identificador-list">
            <option v-for="(item, index) in dataListModelo" :key="index" :value="item"></option>
          </datalist>
          <b-form-text>Se refiere al nombre corto para identificar la pregunta en la bd. (Ej. nombreCompleto, fechaNacimiento), no admite espacios, caracteres especiales ni tildes. Puede usar uno de los identificadores predefinidos asociados al modelo ubicados a la derecha</b-form-text>
        </b-form-group>
        <b-form-group label="Tipo de campo de la pregunta:" label-for="select-tipo" :invalid-feedback="errores.tipo">
          <b-form-select id="select-tipo" v-model="pregunta.tipo" :state="$empty(errores.tipo)" trim :disabled="disabled.tipo">
            <b-select-option v-for="(v, k) in tiposPregunta" :key="k" :value="k">{{ v.label }}</b-select-option>
          </b-form-select>
        </b-form-group>
        <b-form-group :label="pregunta.tipo === 'parrafo' ? 'Título de la pregunta:' : 'Texto de la pregunta:'" label-for="input-texto" :invalid-feedback="errores.texto">
          <b-form-textarea id="input-texto" v-model="pregunta.texto" :state="$empty(errores.texto)" trim></b-form-textarea>
        </b-form-group>
        <b-form-group :label="pregunta.tipo === 'parrafo' ? 'Texto del párrafo:' : 'Texto de ayuda de la pregunta:'" label-for="input-ayuda" :invalid-feedback="errores.ayuda" :state="$empty(errores.ayuda)">
          <vue-editor id="input-ayuda" v-model="pregunta.ayuda" v-if="pregunta.tipo === 'parrafo'" :editor-toolbar="toolbar"></vue-editor>
          <b-form-textarea id="input-ayuda" v-model="pregunta.ayuda" v-else trim></b-form-textarea>
        </b-form-group>
        <b-form-group label="Grupo al que pertenece la pregunta:" label-for="select-grupo-id" :invalid-feedback="errores.grupo_id">
          <b-form-select id="select-grupo-id" v-model="pregunta.grupo_id" :state="$empty(errores.grupo_id)" trim>
            <b-select-option v-for="grupo in grupos" :key="grupo.id" :value="grupo.id">{{ grupo.nombre }}</b-select-option>
          </b-form-select>
          <b-form-text>Bloque al que pertenece la pregunta</b-form-text>
        </b-form-group>
        <template v-if="pregunta.tipo !== 'parrafo'">
          <b-form-group label="Opciones de la pregunta:" label-for="input-meta-opciones" :invalid-feedback="errores.meta" v-if="showOpciones">
            <b-input-group>
              <b-form-textarea id="input-texto" v-model="pregunta.meta.opciones" :state="$empty(errores.meta)" :placeholder="'valor1:Texto de la opcion 1\nvalor2:Texto de la opcion 2'" trim :readonly="disabled.meta"></b-form-textarea>
              <template #append>
                <b-dropdown text="Listados predefinidos" variant="outline-success" :disabled="disabled.tipo">
                  <b-dropdown-item v-for="clase in clases" :key="clase" @click="usarClase(clase)">{{ clase }}</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-input-group>
            <b-form-text id="input-meta-opciones-help">Son las distintas opciones de respuesta que el usuario podrá seleccionar, con el siguiente formato <span class="text-danger">valor:texto</span>. Ej. <span class="text-danger">libre:Unión libre</span> (valor es lo que se guardará en la base de datos. No utilice espacios, tildes o signos)</b-form-text>
          </b-form-group>
          <b-form-group label="Condicionar a:" label-for="group-condicion" :invalid-feedback="errores.condicion" :state="$empty(errores.identificador)" v-if="preguntasCondicion.length > 0">
            <b-input-group id="group-condicion">
              <template #prepend>
                <b-form-select v-model="pregunta.condicion.identificador">
                  <b-select-option :value="undefined">Pregunta</b-select-option>
                  <b-select-option v-for="(pregunta, index) in preguntasCondicion" :value="pregunta.identificador" :key="index">{{ pregunta.identificador }}: {{ pregunta.texto }}</b-select-option>
                </b-form-select>
                <b-form-select v-model="pregunta.condicion.operador">
                  <b-select-option :value="undefined">Operador</b-select-option>
                  <b-select-option v-for="(v, k) in operadores" :key="k" :value="k">{{ v.label }}</b-select-option>
                </b-form-select>
              </template>
              <b-form-input v-model="pregunta.condicion.valor" trim></b-form-input>
              <template #append>
                <b-button variant="danger" @click="limpiarCondicion">
                  <b-icon icon="trash"></b-icon>
                </b-button>
              </template>
            </b-input-group>
            <b-form-text id="input-meta-condicion-help">{{ ayudaCondicion }}</b-form-text>
            <b-form-text id="input-meta-condicion-help-2">Condicionar esta pregunta a la respuesta de una pregunta anterior</b-form-text>
          </b-form-group>
          <b-form-group label="Reglas de la pregunta:" label-for="select-reglas">
            <b-form-checkbox v-model="pregunta.requerida">Esta pregunta es requerida</b-form-checkbox>
            <b-form-checkbox v-model="pregunta.autorellenar">Utilizar respuesta almacenada anteriormente como valor por defecto</b-form-checkbox>
          </b-form-group>
        </template>
        <b-form-group label="Perfiles:" label-for="select-perfiles" :invalid-feedback="errores.perfiles">
          <b-form-checkbox-group id="select-perfiles" v-model="pregunta.perfiles" :state="$empty(errores.perfiles)">
            <b-form-checkbox v-for="perfil in perfiles" :key="perfil.key" :value="perfil.key">{{ perfil.value }}</b-form-checkbox>
          </b-form-checkbox-group>
          <b-form-text>Perfil del usuario a quien va dirigida la pregunta</b-form-text>
        </b-form-group>
        <b-form-group label="Vigencia de la pregunta:" label-for="select-vigencia" :invalid-feedback="errores.vigencia">
          <b-form-select id="select-vigencia" v-model="pregunta.vigencia" :state="$empty(errores.vigencia)" trim>
            <b-select-option v-for="vigencia in vigencias" :key="vigencia.key" :value="vigencia.key">{{ vigencia.value }}</b-select-option>
          </b-form-select>
          <b-form-text>Frecuencia de actualización de la pregunta</b-form-text>
        </b-form-group>
        <b-form-group label="Orden de la pregunta:" label-for="input-orden" :invalid-feedback="errores.orden">
          <b-form-input :placeholder="orden" id="input-orden" type="number" min="0" v-model="pregunta.orden" :state="$empty(errores.orden)" trim></b-form-input>
          <b-form-text>Orden de la pregunta dentro del bloque al que pertenece (de menor a mayor)</b-form-text>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">
          OK
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import _ from 'lodash'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../../services/url_service'

import settings from '../../../settings'

@Component
export default class Preguntas extends Vue {
  public page: number = 1
  public limit: number = 160
  public count: number = 0
  public mainModal: boolean = false
  public preguntasModal: boolean = false
  public errores: any = {}
  public id?: number = null
  public pregunta: any = {
    condicion: {},
    meta: {},
    perfiles: [],
  }
  public filtros: any = {}
  public preguntas: Array<any> = []
  public grupos: Array<any> = []
  public perfiles: Array<any> = []
  public vigencias: Array<any> = []
  public clases: Array<any> = []
  public modelo: Array<any> = []
  public encuestaId?: number = null
  public encuesta: any = {}
  public campos: any = [
    {
      key: 'grupo',
    },
    {
      key: 'identificador',
    },
    {
      key: 'tipo',
    },
    {
      key: 'texto',
    },
    {
      key: 'vigencia',
    },
    {
      key: 'orden',
    },
    {
      key: 'acciones',
    },
  ]
  private _editar: boolean = false

  public toolbar: any = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"]
  ]

  get orden(): string {
    if (this.pregunta.grupo_id) {
      let self = this
      let orden = parseInt(this.grupos.find(function (grupo) {
        return grupo.id == self.pregunta.grupo_id
      })?.pregunta_orden ?? 0)
      return `Siguiente: ${orden + 100}`
    }
    return 'Seleccione un grupo'
  }

  get ayudaCondicion() {
    let pregunta = this.preguntas.find(
      (p) => p.identificador === this.pregunta.condicion.identificador
    )
    if (['m-select', 'm-radio', 'm-check'].includes(pregunta?.tipo)) {
      return `Opciones: ${pregunta.opciones_autocompletar.join(', ')}, NULL`
    } else if ('sino' === pregunta?.tipo) {
      return 'Opciones: SI, NO, NULL'
    }
    return ''
  }

  get operadores() {
    return settings.operadores
  }

  get tiposPregunta() {
    return settings.tiposPregunta
  }

  get showOpciones() {
    return this.tiposPregunta[this.pregunta?.tipo]?.opciones || false
  }

  get preguntasCondicion() {
    let self = this
    return this.preguntas.filter(function (pregunta) {
      return (
        [
          'sino',
          'm-select',
          'm-radio',
          'm-check',
          'entero',
          'decimal',
        ].includes(pregunta.tipo) && pregunta.id != self.id
      )
    })
  }

  get disabled() {
    let self = this
    let modelo = this.modelo.find(function (val) {
      return val.id === self.pregunta.identificador
    })
    if (modelo) {
      return {
        identificador: true,
        tipo: true,
        meta: true,
      }
    }
    return {
      identificador: false,
      tipo: false,
      meta: false,
    }
  }

  get dataListModelo() {
    return this.modelo
      ? this.modelo.map(function (item) {
        return item.id
      })
      : []
  }

  public nombreGrupo(pregunta) {
    return (this.grupos.find(function (grupo) {
      return grupo.id === pregunta.grupo_id
    }))?.nombre
  }

  public nombreVigencia(pregunta) {
    return (this.vigencias.find(function (vigencia) {
      return vigencia.key === pregunta.vigencia
    }))?.value
  }

  public nombreTipoCampo(pregunta) {
    return this.tiposPregunta[pregunta.tipo].label
  }

  public async cargarEncuesta() {
    try {
      let response = await axios.get(
        url.create(`/internal/dinamicas/${this.encuestaId}`)
      )
      this.encuesta = response.data
    } catch (ex) {
      this.$router.replace({ name: 'dinamicas' })
    }
  }
  public async cargarPreguntas() {
    let response = await axios.get(
      url.create(`/internal/dinamicas/${this.encuestaId}/preguntas`),
      {
        params: {
          filtros: this.filtros,
          limit: this.limit,
          page: this.page,
        },
      }
    )
    this.preguntas = response.data.data
    this.count = response.data.count
  }
  public async cargarGrupos() {
    let response = await axios.get(
      url.create(`/internal/dinamicas/${this.encuestaId}/grupos`)
    )
    this.grupos = response.data
  }
  public async cargarPerfiles() {
    let response = await axios.get(url.create(`/public/enums/perfiles`))
    this.perfiles = response.data
  }
  public async cargarVigencias() {
    let response = await axios.get(url.create(`/public/enums/vigencias`))
    this.vigencias = response.data
  }
  public async cargarClases() {
    let response = await axios.get(
      url.create(`/internal/dinamicas/clases_enum`)
    )
    this.clases = response.data
  }
  public async cargarModelo() {
    let response = await axios.get(url.create(`/internal/dinamicas/modelo`))
    this.modelo = response.data
  }
  public usarClase(clase) {
    this.$set(this.pregunta.meta, 'opciones', `_class:${clase}`)
  }
  public usarModelo(campo) {
    if (!campo) {
      this.$set(this.pregunta, 'identificador', null)
      this.$set(this.pregunta, 'tipo', null)
      this.$set(this.pregunta, 'texto', null)
      this.$set(this.pregunta, 'ayuda', null)
      this.$set(this.pregunta, 'meta', {})
    } else {
      this.$set(this.pregunta, 'identificador', campo.id)
    }
  }
  public async agregar() {
    this.errores = {}
    this.mainModal = true
    this.id = null
    this.pregunta = {
      condicion: {},
      meta: {},
      perfiles: [],
    }
  }
  public async editar(pregunta) {
    this.errores = {}
    this.mainModal = true
    this.id = pregunta.id
    this._editar = true
    this.pregunta = {
      identificador: pregunta.identificador,
      grupo_id: pregunta.grupo_id,
      tipo: pregunta.tipo,
      texto: pregunta.texto,
      ayuda: pregunta.ayuda,
      orden: pregunta.orden,
      condicion: pregunta.condicion || {},
      meta: pregunta.meta || {},
      requerida: pregunta.requerida || false,
      autorellenar: pregunta.autorellenar || false,
      perfiles: pregunta.perfiles || [],
      vigencia: pregunta.vigencia,
    }
    this.$nextTick(function () {
      this._editar = false
    })
  }
  public limpiarCondicion() {
    this.pregunta.condicion = {}
  }
  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }
  public async guardar() {
    try {
      this.errores = {}
      let promise = this.id
        ? axios.put(
          url.create(
            `/internal/dinamicas/${this.encuestaId}/preguntas/${this.id}`
          ),
          this.pregunta
        )
        : axios.post(
          url.create(`/internal/dinamicas/${this.encuestaId}/preguntas`),
          this.pregunta
        )
      let response = await promise
      this.mainModal = false
      await this.cargarGrupos()
      this.cargarPreguntas()
    } catch (ex) {
      this.errores = ex.response.data
    }
  }

  public async eliminar(pregunta) {
    try {
      if (await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar esta pregunta?')) {
        await axios.delete(
          url.create(
            `/internal/dinamicas/${this.encuestaId}/preguntas/${pregunta.id}`
          )
        )
        await this.cargarGrupos()
        await this.cargarPreguntas()
      }
    } catch (ex) {

    }
  }

  @Watch('page')
  public pageChange(value) {
    this.cargarPreguntas()
  }

  @Watch('pregunta.identificador')
  public identificadorChange(value) {
    if (this._editar) {
      this._editar = false
      return
    }
    let self = this
    _.debounce(function (value) {
      let campo = self.modelo.find(function (item) {
        return value === item.id
      })
      if (campo) {
        self.$set(self.pregunta, 'tipo', campo.tipo)
        if (campo.texto) {
          self.$set(self.pregunta, 'texto', campo.texto)
        }
        if (campo.ayuda) {
          self.$set(self.pregunta, 'ayuda', campo.ayuda)
        }
        if (campo.meta) {
          self.$set(self.pregunta, 'meta', campo.meta)
        }
      }
    }, 500)(value)
  }
  created() {
    this.encuestaId = parseInt(this.$route.params['id'])
    this.cargarEncuesta()
    this.cargarPreguntas()
    this.cargarGrupos()
    this.cargarPerfiles()
    this.cargarVigencias()
    this.cargarClases()
    this.cargarModelo()
  }
}
</script>

<style lang="scss">
@import '~bootswatch/dist/flatly/variables';
.dropdown-menu {
  overflow-y: auto;
  max-height: 98vh;
}
.input-group-prepend {
  & > .custom-select {
    height: auto;
    border-color: var(--white);
    background-color: var(--cyan);
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e");
    color: var(--white);
    text-overflow: ellipsis;
    text-overflow: ellipsis;
    & > option {
      background-color: var(--white);
      color: var(--dark);
    }
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child) {
      border-radius: 0;
    }
  }
}
.table tr > td[rowspan]:first-child {
  font-weight: 900;
}

.ql-editor {
  & blockquote,
  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6,
  & ol,
  & p,
  & pre,
  & ul {
    margin-bottom: 1em !important;
  }
}
</style>